export default __webpack_public_path__ + "static/media/stats-banner.191716dd.jpg";